import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const deleteVendorQuery = (id) => {
  return axios.post(`${apiurl?.deleteVendor}?vendorMasterID=${id}`);
};

const deleteVendor = () => {
  const queryClient = useQueryClient();
  return useMutation(['deleteVendor'], deleteVendorQuery, {
    onSuccess: () => {
      queryClient.invalidateQueries('getvendorlist');
    }
  });
};

export default deleteVendor;
